class LampeshkaCarousel extends HTMLElement {
  constructor() {
    super();
    this.carousel = this.querySelector('.lampeshka-carousel__track');
    this.items = this.querySelectorAll('.lampeshka-carousel__item');
    this.container = this.closest('.page-width');
    this.prevButton = this.container ? this.container.querySelector('.lampeshka-carousel__button--prev') : null;
    this.nextButton = this.container ? this.container.querySelector('.lampeshka-carousel__button--next') : null;
    
    if (!this.carousel || !this.items.length) return;
    
    this.init();
  }
  
  init() {
    // Set up scroll snapping
    this.carousel.style.scrollSnapType = 'x mandatory';
    this.carousel.style.scrollBehavior = 'smooth';
    
    // Set up items
    this.items.forEach(item => {
      item.style.scrollSnapAlign = 'start';
    });
    
    // Set up event listeners
    this.carousel.addEventListener('scroll', this.updateButtons.bind(this));
    
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.scroll('prev'));
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.scroll('next'));
    }
    
    // Initial button state
    this.updateButtons();
    
    // Handle resize
    window.addEventListener('resize', this.updateButtons.bind(this));
  }
  
  scroll(direction) {
    const itemWidth = this.items[0].offsetWidth;
    const gap = this.getGap();
    const scrollAmount = itemWidth + gap;
    
    if (direction === 'prev') {
      this.carousel.scrollLeft -= scrollAmount;
    } else {
      this.carousel.scrollLeft += scrollAmount;
    }
  }
  
  getGap() {
    const styles = window.getComputedStyle(this.carousel);
    return parseInt(styles.gap) || parseInt(styles.columnGap) || 0;
  }
  
  updateButtons() {
    if (!this.prevButton || !this.nextButton) return;
    
    const scrollLeft = this.carousel.scrollLeft;
    const scrollWidth = this.carousel.scrollWidth;
    const clientWidth = this.carousel.clientWidth;
    
    // Update previous button
    if (scrollLeft <= 1) {
      this.prevButton.disabled = true;
      this.prevButton.setAttribute('aria-disabled', 'true');
    } else {
      this.prevButton.disabled = false;
      this.prevButton.setAttribute('aria-disabled', 'false');
    }
    
    // Update next button
    if (scrollLeft + clientWidth >= scrollWidth - 1) {
      this.nextButton.disabled = true;
      this.nextButton.setAttribute('aria-disabled', 'true');
    } else {
      this.nextButton.disabled = false;
      this.nextButton.setAttribute('aria-disabled', 'false');
    }
  }
}

customElements.define('lampeshka-carousel', LampeshkaCarousel);